import React from 'react';
import { Chip } from '@mui/material';
import moment from 'moment';
import { dateMonthYearDateFormat } from '../../../constants';

const AnalyticsFilterOutput = ({ filter, filterMenu, onRemoveFilter }) => {
    const plotFilterValue = (key) => {
        const config = filterMenu[key];
        const isClearable = config.clearable !== false;
        const onDelete = isClearable ? () => onRemoveFilter(key) : undefined;

        switch (config.inputType) {
            case 'text':
            case 'number':
                return (
                    <Chip
                        size='small'
                        label={
                            <span>
                                <span style={{ fontWeight: 500, fontFamily: 'Conv_IBMPlexSans-Medium' }}>{config.title}</span>: {filter[key]}
                            </span>
                        }
                        onDelete={onDelete}
                    />
                );
            case 'dropdown': {
                const { options, valueKey, labelKey, multiple } = config;
                if (multiple) {
                    const selected = options?.filter((item) =>
                        filter[key].toString().split(',').includes(item[valueKey].toString())
                    );
                    const value = selected?.map((item) => item[labelKey]).join(', ');
                    return value ? (
                        <Chip
                            size='small'
                            label={
                                <span>
                                    <span style={{ fontWeight: 500, fontFamily: 'Conv_IBMPlexSans-Medium' }}>{config.title}</span>: {value}
                                </span>
                            }
                            onDelete={onDelete}
                        />
                    ) : null;
                } else {
                    const found = options?.find((item) => item[valueKey] === filter[key]);
                    return found ? (
                        <Chip
                            size='small'
                            label={
                                <span>
                                    <span style={{ fontWeight: 500, fontFamily: 'Conv_IBMPlexSans-Medium' }}>{config.title}</span>: {found[labelKey]}
                                </span>
                            }
                            onDelete={onDelete}
                        />
                    ) : null;
                }
            }
            case 'date':
                return (
                    <Chip
                        size='small'
                        label={
                            <span>
                                <span style={{ fontWeight: 500, fontFamily: 'Conv_IBMPlexSans-Medium' }}>{config.title}</span>:{' '}
                                {moment(filter[key]).format(config.format || dateMonthYearDateFormat)}
                            </span>
                        }
                        onDelete={onDelete}
                    />
                );
            case 'checkbox':
                return (
                    <Chip
                        size='small'
                        label={
                            <span>
                                <span style={{ fontWeight: 500, fontFamily: 'Conv_IBMPlexSans-Medium' }}>{config.title}</span>: {filter[key] ? 'Yes' : 'No'}
                            </span>
                        }
                        onDelete={onDelete}
                    />
                );
            default:
                return null;
        }
    };

    const orderedFilter = Object.keys(filterMenu).reduce((acc, key) => {
        if (filter[key] !== undefined && filter[key] !== null && filter[key] !== '') {
            acc[key] = filter[key];
        }
        return acc;
    }, {});

    const hasClearableFilter = Object.keys(orderedFilter).some((key) => filterMenu[key]?.clearable !== false);

    return (
        <>
            {Object.keys(orderedFilter).map((key, index) =>
                filterMenu[key] ? <React.Fragment key={index}>{plotFilterValue(key)}</React.Fragment> : null
            )}
            {hasClearableFilter && (
                <Chip
                    color='primary'
                    size='small'
                    label='Clear All'
                    onDelete={() => onRemoveFilter('all')}
                />
            )}
        </>
    );
};

export default AnalyticsFilterOutput;
